<template>
    <!-- PC端我的发布页面 -->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
    <div class="container errong">
        <ZhaiJiuGongPC menu="3"></ZhaiJiuGongPC>
        <div class="container-fluid mt-2">
            <div class="row shengse">
                <div class="dixian px-3 py-2 d-flex justify-content-between">
                    <div class="lf">我的发布</div>
                </div>
                <div style="font-size: 0.9rem; padding:1em; color:red;">
                    <strong>发帖权限：</strong>
                    <template v-if="getUser && getUser.level_expire_date && new Date() <= new Date(getUser.level_expire_date)">
                        正常（拒审两次将被禁止发帖）
                    </template>
                    <template v-else>
                        无权限（需开通会员）
                    </template>
                </div>
                <!-- 付费置顶提示 -->
                <div style="font-size: 0.9rem; padding:0 1em 1em; ">
                    <strong>付费置顶：</strong>帖子审核通过后，可以通过“付费置顶”按钮来自助置顶推广，如果没有置顶选项是因为无法验证手持是本人，请联系客服验证即可。
                </div>
                <div style="font-size: 0.9rem; padding:0 1em 1em; ">
                    <strong>发帖必读：</strong>不要用同一张手持多次重复发帖，或着换着账号发帖，否则全部删贴封号。如需推广请使用付费置顶功能。
                </div>
            </div>
        </div>

        <!-- 卡片区域 -->

            <div class="row card-container mt-2">
                <div class="col-md-4 mb-1" v-for="post in posts" :key="post.id">
                    <a @click.prevent="handleCardClick(post)" class="card-link" v-if="post && post.id">
                        <div class="card h-100">
                            <div class="row g-0 h-100">
                                <div class="col-4 p-0 d-flex align-items-center justify-content-center">
                                    <div class="image-container">
                                        <img :src="post.img" alt="..." class="card-img">
                                    </div>
                                </div>
                                <div class="col-8 d-flex flex-column h-100">
                                  <!-- 添加付费置顶按钮 -->
                                  <button
                                      class="btn btn-warning position-absolute top-0 end-0 m-2"
                                       @click.stop="onTopClick(post)"
                                  >
                                    付费置顶
                                  </button>
                                    <div class="card-body p-1 d-flex flex-column h-100">
                                        <div class="header flex-shrink-0">
                                            <h5 class="card-title mt-3">{{ post.name }}</h5>
                                            <div class="ri mb-1 mt-2">
                                                <i class="bi bi-clock riqiziti" id="upload-date">
                                                    <span>&nbsp;{{ post.createTime.substr(0, 10) }}&nbsp;&nbsp;</span>
                                                </i>
                                                <i class="bi bi-star-fill riqiziti" id="collect">
                                                    <span>&nbsp;{{ post.collectCount }}{{ post.collection }}</span>
                                                </i>
                                            </div>
                                        </div>
                                        <div class="content flex-grow-1">
                                            <p class="card-text">{{ post.history }}</p>
                                        </div>
                                        <div class="footer mb-2 flex-shrink-0">
                                            <span class="bi bi-send-fill weiz changlv" id="location">
                                                &nbsp;{{ post.province }}-{{ post.city }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="bg-white my-2 p-3 G-Field text-center d-flex justify-content-center align-items-center">
                <a class="page-link pagination-btn" href="#" aria-label="Previous" @click.prevent="prevPage"
                   :disabled="currentPage === 1">
                    <span aria-hidden="true">«</span>
                </a>
                <span style="margin: 0 1rem;">第 {{ currentPage }} 页，共 {{ totalPages }} 页</span>
                <a class="page-link pagination-btn" href="#" aria-label="Next" @click.prevent="nextPage"
                   :disabled="currentPage === totalPages">
                    <span aria-hidden="true">»</span>
                </a>
            </div>

        </div>



  <!-- 模态框 -->
  <div class="modal fade" id="onTopModal" tabindex="-1" aria-labelledby="onTopModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="onTopModalLabel">付费置顶</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div id="step1">
            <div>
              付费置顶，价格高的帖子靠前！<strong>有效期一天！</strong>
            </div>
              <div class="mt-2"><strong>起始价格：</strong><span id="payamount1">50元/天</span></div>
            <div class="mt-2"><strong>当前最大价格：</strong><span id="payamount">{{ modalData.maxPrice }}元</span></div>
            <div class="mt-2"><strong>您的价格：</strong><span id="uplevel">{{ modalData.yourPrice }}元</span></div>
            <div class="mt-2">
              <strong>继续加价：</strong>
<!--              <input type="number" name="money" value="0.00" v-model="money">-->
              <input
                  type="number"
                  name="money"
                  v-model="money"
                  @keydown.prevent="incrementOnKey"
              />
              <button @click="incrementMoney">增加50元</button>
            </div>
              <div class="mt-2">
                  <strong>支付方式：</strong>
                  <label class="pay-option1">
                      <input type="radio" name="paytype" value="2040" v-model="payType" id="alipay">
                      支付宝
                  </label>
                  <label class="pay-option">
                      <input type="radio" name="paytype" value="2080" v-model="payType" id="mobileBank">
                      手机银行
                  </label>
              </div>
              <div class="mt-2" style="color:red;">
                  如果支付加载不出来，多试几次就成功了。
              </div>
            <div class="text-center mt-2">
              <button class="btn btn-success" @click="startPayment">支付</button>
              <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
            </div>

          </div>
          <div id="step2">
            <div id="paymsg" style="text-align: center;font-size: 1rem;font-weight: bold;"></div>
            <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">请使用手机相机扫描二维码，不支持微信/支付宝扫一扫</p>
            <p style="text-align: center;font-size: 1rem;color: #000;">请确认支付完成后，再点击“支付完成”</p>
            <div class="text-center">
              <button id="btnpaysucess" class="btn btn-primary mr-5" @click="onManualCheckPayment">支付完成</button>
              <button class="btn btn-primary mr-5" data-bs-dismiss="modal">关闭</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 成功模态框 -->
  <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
      <div class="modal-content">
        <div class="modal-body d-flex align-items-center justify-content-center">
          <i class="bi bi-emoji-smile" style="font-size: 2rem; color: #00c26f;"></i>
          <p class="mb-0 ms-2" id="successMessage" style="font-size: 1rem; color: #00c26f;"></p>
        </div>
      </div>
    </div>
  </div>

  <!-- 失败模态框 -->
  <div class="modal fade" id="generalErrorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 350px;">
      <div class="modal-content">
        <div class="modal-body d-flex align-items-center justify-content-center">
          <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #dc3545;"></i>
          <p class="mb-0 ms-2" id="errorMessage" style="font-size: 1rem; color: #dc3545;"></p>
        </div>
      </div>
    </div>
  </div>
    <!-- 时间限制提示模态框 -->
    <div class="modal fade" id="timeRestrictionModal" tabindex="-1" aria-labelledby="timeRestrictionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 350px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-clock" style="font-size: 2rem; color: red;"></i>
                    <p class="mb-0 ms-2" id="timeRestrictionMessage" style="font-size: 1rem; color: red;"></p>
                </div>
            </div>
        </div>
    </div>

  <ZhaiFootPC></ZhaiFootPC>
</template>


<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiJiuGongPC from "../componentspc/ZhaiJiuGongPC";
    import http from "../utils/http.js";
    import { mapGetters } from 'vuex';
    import {Modal} from "bootstrap";
    import QRCode from "qrcodejs2";

    export default {
        name: "PMyRelease",
        components: { ZhaiHeadPC, ZhaiFootPC, ZhaiJiuGongPC },
        data() {
            return {
                payType: '2040',
                posts: [], // 帖子数据
                currentPage: 1, // 当前页码
                pageSize: 24, // 每页大小
                totalPages: 1, // 总页数
                modalData: { yourPrice: '', maxPrice: '' },
                money: 50.00, // 初始值
                bbsId: null,
            };
        },
        computed: {
            ...mapGetters(['getUser']), // 从 Vuex 获取用户数据
        },
        mounted() {
            this.fetchPosts(); // 组件挂载时加载帖子数据
        },
        methods: {
            // 显示时间限制提示模态框
            showTimeRestrictionModal(message) {
                document.getElementById('timeRestrictionMessage').innerText = message;
                const timeModal = new Modal(document.getElementById('timeRestrictionModal'));
                timeModal.show();

                // 3秒后自动关闭
                setTimeout(() => {
                    timeModal.hide();
                }, 5000);
            },
            fetchPosts() {
                if (!this.getUser) {
                    console.error('用户未登录');
                    return;
                }
                const userId = this.getUser.id;// 获取当前用户的ID
                const url = `/platform/frontEnd/myRelease?userid=${userId}&pageNum=${this.currentPage}&pageSize=${this.pageSize}`;

                http.get(url) // 发送HTTP GET请求获取数据
                    .then(response => {
                        if (response.data && response.data.status === 1) {
                            this.posts = response.data.data.list; // 获取帖子列表
                            this.totalPages = Math.ceil(response.data.data.total / this.pageSize);
                        } else {
                            console.error('获取发布信息失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('API 请求错误:', error);
                    });
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.fetchPosts();
                }
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    this.fetchPosts();
                }
            },
            handleCardClick(post) {
                console.log("Card clicked!", post);
                this.$router.push({
                    name: 'detailPage',
                    query: { id: post.id }
                });
            },
            onTopClick(post) {
              // 自定义逻辑处理付费置顶操作
              // alert("付费置顶功能点击！" + post.id);
              this.openModal(post)// 打开模态框，显示付费置顶的相关信息
            },
            openModal(post) {

              this.bbsId = post.id// 记录当前帖子的ID

              http.get(`/platform/frontBbsPayTop/getBbsNewlyPriceDetail?bbsId=${post.id}`)
                  .then(response => {
                    if (response.data && response.data.status === 1) {
                      this.modalData.yourPrice = response.data.data.yourPrice;
                      this.modalData.maxPrice = response.data.data.maxPrice;
                      // this.money = this.modalData.yourPrice;
                    } else {
                      console.error('获取发布信息失败:', response.data.msg);
                    }
                  })
                  .catch(error => {
                    console.error('API 请求错误:', error);
                  });

                // 显示模态框中的第一个步骤
              document.getElementById('step1').style.display = 'block';
              document.getElementById('step2').style.display = 'none';
              const modalElement = document.getElementById('onTopModal');
              const modalInstance = new Modal(modalElement);// 创建Bootstrap模态框实例
              modalInstance.show(); // 显示模态框
            },
          incrementMoney() {
            this.money = (parseFloat(this.money) + 50).toFixed(2); // 增加 50 并保留两位小数
          },
          // 发起支付请求并生成二维码
          startPayment() {
              // 检查当前时间是否在 23:30 至 0:00 之间
              const now = new Date();
              const hours = now.getHours();
              const minutes = now.getMinutes();

              if ((hours === 23 && minutes >= 30) || (hours === 0)) {
                  this.showTimeRestrictionModal("请于0点后再点击支付，每日23:30至0点为财务系统结算时间。");
                  return;
              }

            const payButton = document.querySelector('#step1 .btn-success');
            payButton.textContent = '生成中';
            payButton.disabled = true;

            console.log('用户信息:', this.getUser);

            const { id: userid, username, email } = this.getUser || {};
            if (!userid || !username || !email) {
              alert("用户信息不完整，请重新登录！");
              return;
            }

            // 构建后端请求 URL
            const requestUrl = `/platform/frontBbsPayTop/createOrder?bbsId=${this.bbsId}&money=${this.money}&userId=${userid}&paytype=${this.payType}`;
              // 发送支付请求
              http.get(requestUrl)
                  .then(response => {
                      const res = response.data;

                      // ✅ 正确判断是否成功：status === 1
                      if (res && res.status === 1 && res.data) {
                          const payUrl = res.data.payUrl;
                          const mchOrderNo = res.data.outTradeNo;

                          if (!payUrl) {
                              alert("支付链接为空，请联系管理员！");
                              return;
                          }

                          this.orderId = mchOrderNo;
                          this.generateQRCode(payUrl);
                      } else {
                          const errorMessage = res?.msg || '未知错误';
                          alert(`支付请求失败: ${errorMessage}`);
                      }
                  })
                  .catch(error => {
                      alert(`请求支付失败，请重试。错误详情: ${error.message}`);
                  });


          },

          // 生成二维码并展示在页面上
          generateQRCode(payUrl) {
            console.log("生成二维码的链接:", payUrl);
            document.getElementById('paymsg').innerHTML = '请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付。';

            // 创建二维码容器
            const qrCodeContainer = document.createElement('div');
            qrCodeContainer.id = 'qrcode';
            qrCodeContainer.style.width = '200px';
            qrCodeContainer.style.height = '200px';
            qrCodeContainer.style.marginTop = '20px';

            document.getElementById('paymsg').appendChild(qrCodeContainer);

            // 生成二维码
            new QRCode(qrCodeContainer, {
              text: payUrl,
              width: 200,
              height: 200,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H
            });

            document.getElementById('step1').style.display = 'none';
            document.getElementById('step2').style.display = 'block';

            // 设置倒计时时间
            let remainingTime = 300; // 5分钟倒计时（300秒）

            // 添加倒计时显示
            const countdown = document.createElement('p');
            countdown.id = 'countdown';
            countdown.style.textAlign = 'center';
            countdown.style.marginTop = '10px';
            document.getElementById('paymsg').appendChild(countdown);
            countdown.style.fontWeight = "normal";
            countdown.style.color = "rgba(255, 127, 127)";
            countdown.style.fontSize = "0.9rem";

            // 开始倒计时
            const timer = setInterval(() => {
              if (remainingTime <= 0) {
                clearInterval(timer);
                countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
                qrCodeContainer.style.filter = "blur(5px)";
              } else {
                const minutes = Math.floor(remainingTime / 60);
                const seconds = remainingTime % 60;
                countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? '0' + seconds : seconds} 内完成支付`;
                remainingTime--;
              }
            }, 1000);
          },
          // 用户点击支付完成按钮进行手动轮询
          onManualCheckPayment() {
            this.manualPolling = true; // 设置手动轮询标识
            if (!this.orderId) return;
            const statusUrl = `/platform/frontBbsPayTop/checkPaymentStatus?mchOrderNo=${this.orderId}`;
            http.get(statusUrl)
                .then(response => {
                  if (response.data && response.data.status === 1) {
                    this.handlePaymentSuccessStatus();
                  } else if (this.manualPolling) {
                    // 手动轮询时的失败提示
                    this.showFailureModal("未检测到支付完成，请稍后重试");
                  }
                })
                .catch(error => {
                  console.error("轮询支付状态异常:", error);
                });
          },
          // 处理支付成功的逻辑
          handlePaymentSuccessStatus() {
              // 关闭“支付”模态框
              const payModal = Modal.getInstance(document.getElementById('onTopModal'));
              if (payModal) {
                  payModal.hide();
              }
              // 显示成功模态框
            document.getElementById('successMessage').innerText = "支付已成功";
            const successModal = new Modal(document.getElementById('successModal'));
            successModal.show();

            // 设置3秒后自动关闭模态框并跳转到会员中心页面
            setTimeout(() => {
              successModal.hide(); // 关闭模态框
              this.$router.push('/memberCenter'); // 跳转到会员中心页面
            }, 3000); // 3秒 = 3000毫秒
          },

          // 显示支付失败模态框，并在3秒后自动关闭
          showFailureModal(message) {
            document.getElementById('errorMessage').innerText = message;
            const errorModal = new Modal(document.getElementById('generalErrorModal'));
            errorModal.show();

            // 设置3秒后自动关闭模态框
            setTimeout(() => {
              errorModal.hide(); // 关闭模态框
            }, 3000); // 3秒 = 3000毫秒
          },
        }
    };
</script>


<style scoped>
    .card {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        border: none;
        cursor: pointer !important;
    }
    .col-4 {
        width: 115px;
        height: 155px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0;
    }
    .image-container {
        width: 99px;
        height: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 4px;
    }
    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .col-8 {
        max-height: 155px;
    }
    .card-body {
        display: flex;
        flex-direction: column;
        padding: 0.1rem;
        height: 100%;
    }
    .card-title {
        font-size: 1rem;
    }
    .card-text {
        margin-bottom: 0.5rem !important;
        font-size: 0.9rem !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .daxiao {
        font-size: 0.75rem !important;
    }
    .ri {
        display: flex;
        align-items: center;
        font-size: 0.8rem;
    }
    .riqiziti {
        font-style: normal;
        font-size: 0.8rem;
        margin-right: 4px;
    }
    .ri i + i {
        margin-left: 4px;
    }
    .changlv {
        color: #18b371 !important;
    }
    .content {
        display: flex;
        flex-direction: column;
        margin-top: 0.2rem;
    }
    .card-link {
        text-decoration: none;
        color: inherit;
    }
    .weiz {
        font-size: 0.9rem;
    }
    /* 按钮样式调整（可根据需求定制） */
    .btn-warning {
      z-index: 10;
      font-size: 0.9rem;
      padding: 0.4rem 0.8rem;
    }


    /*四个绿色按钮的颜色还包括模态框按钮*/
    .btn-success {
      background-color: #00c26f !important;
      border: none !important;
    }
    /*支付完成和关闭按钮*/
    #btnpaysucess, .modal-body .btn-primary {
      background-color: #00c26f !important;
      border: none !important;
    }

    /* 设置按钮的右边距，以添加间隙 */
    .btn {
      margin-right: 10px;
    }

    /* 移除最后一个按钮的右边距，以防止不必要的空间 */
    .btn:last-child {
      margin-right: 0;
    }

    /*付款提醒*/
    .buyinfo {
      background: #f1f1f1;
      padding: 20px;
      color: red !important;
    }

    /*升级帮助里面的问题*/
    .uphelp h1, p {
      font-size: 0.7rem;
    }

    /* 增加升级帮助板块与上方内容的间距 */
    .upgrade-help {
      margin-top: 1rem; /* 可以根据需要调整数值 */
    }

    /*四个按钮的字体*/
    .btn {
      font-size: 1rem;
    }
    .modal-title {
      font-size: 1rem;
    }

    /* 增加模态框中两个按钮的间距 */
    .modal-body .btn {
      margin-right: 60px; /* 调整为合适的数值 */
    }

    .modal-body .btn:last-child {
      margin-right: 0; /* 确保最后一个按钮没有多余的右边距 */
    }
    @media (min-width: 768px) {
      .zhai-head {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;
      }
      .errong {
        margin-top: 90px; /* 根据导航栏高度调整 */
      }
    }
    #paymsg {
      color: #00c26f;
      display: flex;
      flex-direction: column;
      align-items: center; /* 垂直居中 */
    }

    #qrcode {
      margin-top: 20px; /* 给二维码顶部增加一些间距 */
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      transition: filter 0.5s ease; /* 增加二维码模糊效果的过渡动画 */
    }
    #countdown {
      font-size: 0.7rem;
      color: red !important;
      text-align: center;

    }
    /*隐藏输入框右侧上下箭头*/
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    /*支付宝选项与右侧间距*/
    .pay-option1{
        margin-right: 40px;
    }

</style>
